import { calculateSecondsToMinutes } from '@/utils/helpers';
import styles from '../verification-form.module.scss';
import useTimer from '@/hooks/use-timer/use-timer';
import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/button/button';

interface VerificationTimerProps {
  duration?: number;
  onResendCode: () => void;
  codeResent?: boolean;
}

export default function VerificationTimer({
  duration = 180,
  onResendCode,
  codeResent = false,
}: VerificationTimerProps) {
  const { t } = useTranslation('auth');
  const handleSendNewCode = () => {
    setTimeLeft(duration);
    onResendCode();
  };

  const { timeLeft, setTimeLeft } = useTimer(duration);
  return (
    <Flex vertical>
      <p>{t('verification.timer.notReceived')}</p>
      <Flex align="center" className={styles.linkContainer}>
        {timeLeft > 0 || codeResent ? (
          <p>{t('verification.timer.resendIn', { time: calculateSecondsToMinutes(timeLeft) })}</p>
        ) : (
          <Button buttonVariant="link" onClick={handleSendNewCode} disabled={timeLeft > 0 || codeResent}>
            {t('verification.timer.resend')}
          </Button>
        )}
      </Flex>
    </Flex>
  );
}
